<div>
  <div class="content-card">
    <div fxLayout="row" fxLayoutAlign="center center" class="content">
      <div class="example-container">
        <div class="table-wrapper custom-table">
          <mat-table
            #table
            matSort
            matSortActive="SharingDate"
            matSortDirection="desc"
            matSortDisableClear
            [dataSource]="dataSource.employmentConditionsConfirmations$ | async"
          >
            <ng-container matColumnDef="EmployerName">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'Employer' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.EmployerName }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="AgreementType">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'WL-AgreementType' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.AgreementType }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="EmploymentPeriod">
              <mat-header-cell *matHeaderCellDef mat-sort-header="EmploymentDateFrom" class="hidden-sort">
                {{ 'WL-EmploymentPeriod' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                >{{ element.EmploymentDateFrom | date : 'yyyy-MM-dd' }} - {{ element.EmploymentDateTo | date : 'yyyy-MM-dd' }}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="Status">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'Status' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.Status }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="SharingDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'SharingDate' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.SharingDate | date : 'yyyy-MM-dd' }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="ReadingDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'ReadingDate' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.ReadingDate | date : 'yyyy-MM-dd' }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Actions" stickyEnd>
              <mat-header-cell *matHeaderCellDef class="hidden-sort">
                {{ 'WAD-Actions' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div fxLayout="row">
                  <button
                    mat-icon-button
                    (click)="onShowClick(element)"
                    matTooltip="{{ 'EmploymentConditionsConfirmationList.ShowDocument' | translate }}"
                    matTooltipPosition="above"
                    [visibleWithPermissionsOnWorkerProfile]="['AgreementPreview']"
                    [authServerUserId]="authServerUserId"
                  >
                    <mat-icon class="material-icons-outlined">find_in_page</mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    (click)="onDownloadClick(element)"
                    matTooltip="{{ 'EmploymentConditionsConfirmationList.DownloadDocument' | translate }}"
                    matTooltipPosition="above"
                    [visibleWithPermissionsOnWorkerProfile]="['AgreementPreview']"
                    [authServerUserId]="authServerUserId"
                  >
                    <mat-icon class="material-icons-outlined">file_download</mat-icon>
                  </button>
                </div>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
        <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
